import Service from "./Service";
import { TopDeskErrorResponse } from "../../Constant";

class ClaimApiService extends Service {
  constructor() {
    super("api");
  }

  async create(payload) {
    let result = await this.post(`Claims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async createFeedback(payload) {
    let result = await this.post(`Claims/Feedback`, payload, (status, data) => {
      // if (status === TopDeskErrorResponse) {
      //   return {
      //     errorMessage: "we_have_a_technical_problem_contact_customer_service",
      //     isSuccess: false,
      //     status: 2,
      //   };
      // }
 
      if (data?.isSuccess === false) {
        return {
          errorMessage: "we_have_a_technical_problem_contact_customer_service",
          isSuccess: false,
          status: 2,
        };
      }

      return data;
    });
    return result;
  }

  async getAll(payload) {
    let result = await this.post(`Administration/GetClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getTotalReimbursementSEK(payload) {
    let result = await this.post(`Administration/GetTotalReimbursementSEK`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getCurrentApproveClaimJob() {
    let result = await this.get(`Administration/GetCurrentApproveClaimJob`, (status, data) => {
      return data;
    });
    return result;
  }

  async getApproveClaimJobById(id) {
    let result = await this.getWithoutTracker(`Administration/GetApproveClaimJobById?jobId=${id}`, (status, data) => {
      return data;
    });
    return result;
  }

  async approveClaims(payload) {
    let result = await this.post(`Administration/ApproveClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getClaimsForApprove(payload) {
    let result = await this.post(`Administration/getClaimsForApprove`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getApproveClaims(payload) {
    let result = await this.post(`Administration/GetApproveClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getFraudReport(payload) {
    let result = await this.post(`Administration/GetFraudReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getFraud() {
    let result = await this.get(`Administration/GetFraud`, (status, data) => {
      return data;
    });
    return result;
  }

  async getClaimStatus() {
    let result = await this.get(`Administration/GetClaimStatus`, (status, data) => {
      return data;
    });
    return result;
  }

  async exportSUSFile(payload) {
    let result = await this.post(`Administration/ExportSusFile`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async exportAccountingReport(payload) {
    let result = await this.post(`Administration/ExportAccountingReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new ClaimApiService();
